module.exports = __webpack_public_path__ + "static/media/logo.556d2fea.png";